document.addEventListener('DOMContentLoaded', function () {
  // Find all header-drawer elements (normally there is only one)
  var headerDrawers = document.querySelectorAll('header-drawer');

  if (!headerDrawers.length) return;

  headerDrawers.forEach(function (headerDrawer) {
    // Read the breakpoint from data-breakpoint="tablet" (or mobile/desktop)
    var breakpoint = headerDrawer.dataset.breakpoint || 'mobile';
    var overflowClass = 'overflow-hidden-' + breakpoint;

    // Find ALL custom close buttons inside this header drawer
    var closeButtons = headerDrawer.querySelectorAll('.menu-drawer__close-btn');

    if (!closeButtons.length) return;

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // Find the closest details element that is the menu container
        var details = btn.closest('details');

        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }

        // Remove the scroll lock class that was added when menu opened
        document.body.classList.remove(overflowClass);
      });
    });
  });
});
